import { Pipe, PipeTransform } from '@angular/core';
import { ITableRow } from "../services/table-data/ITable";
import { EHosts } from "libraries/enums/EHosts";
import { IQuotationsQuotation } from 'libraries/service/resources/quotation-quotations/IQuotationsQuotation';

@Pipe({
    name: 'isEditableCell'
})
export class IsEditableCellPipe implements PipeTransform {
    public transform(row: ITableRow, quotation: IQuotationsQuotation, hasPermissionToEdit: boolean): boolean {
        if (!hasPermissionToEdit || quotation.isReadOnly) {
            return false;
        }

        if (row.block && row.block.isEmpty) {
            return true;
        }

        if (row.block && row.block.totalPrices && row.block.totalPrices[0] && row.block.totalPrices[0].externalReference) {
            return row.block.totalPrices[0].externalReference.host === EHosts.WATABI;
        }

        return true;
    }
}